// @flow
import * as React from 'react'
import AngleRightIcon from 'mz-icons/angle-right'
import { Container, Header, NavigateButton } from './elements'
import { getMonthData, getDateFromDateValue } from '../utils'
import MonthRow from '../MonthRow'

// Types
export type Props = {
  value?: any,
  minDate?: Date,
  maxDate?: Date,
  onChange?: Function,
}
type State = {
  month: any,
}

/**
 * DatePicker componentn that shows all months as a list.
 * Call given `onChange` with Date object of selected date when
 * user click on some date which is not in the past.
 * @return {Component}
 */
class ScrollableCalendar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { month: this.getActiveMonth() }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.value !== prevProps.value) {
      this.setState({ month: this.getActiveMonth() })
    }
  }

  getActiveMonth() {
    const { value, minDate, maxDate } = this.props
    return getMonthData(value, minDate, maxDate)
  }

  changeMonth(direction: number) {
    const { minDate, maxDate } = this.props
    const nextMonthDate = this.state.month.days[1][0].date
      .clone()
      .add(direction, 'month')
    this.setState({ month: getMonthData(nextMonthDate, minDate, maxDate) })
  }

  handleChangeDate = (selectedDate: any) => {
    const { onChange, value } = this.props
    const newDate = getDateFromDateValue(value, selectedDate)
    onChange && onChange(newDate)
  }

  handleClickPrev = () => {
    this.changeMonth(-1)
  }

  handleClickNext = () => {
    this.changeMonth(1)
  }

  render() {
    const { value } = this.props
    const { month } = this.state

    return (
      <Container>
        <Header>
          <NavigateButton onClick={this.handleClickPrev}>
            <AngleRightIcon fixedWidth rotate="180deg" />
          </NavigateButton>
          {month.name}
          <NavigateButton onClick={this.handleClickNext}>
            <AngleRightIcon fixedWidth />
          </NavigateButton>
        </Header>
        <MonthRow
          month={month}
          value={value}
          onChange={this.handleChangeDate}
        />
      </Container>
    )
  }
}

export default ScrollableCalendar
